import { StyleSheet, Platform } from "react-native";
import AppTheme from "../AppTheme";

const emptyPageStyles = StyleSheet.create({
  container: {
    backgroundColor: "#FFF",
    flex: 1,
    display: "flex",
    alignItems: "center",
  },
  imageContainer: {
    alignItems: "center",
    marginTop: 24,
    marginBottom: 24,
  },
  largeImage: {
    width: 274,
    height: 247,
    marginTop: 27,
    marginBottom: 40,
  },
  button: {
    height: 32,
    marginTop: 16,
    borderRadius: 6,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
  overlay: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 50,
    zIndex: 1000,
  },
  overlayButton: {
    width: 158,
    borderRadius: 6,
    height: 40,
    backgroundColor: "#F3F2F1",
  },
  overlayButtonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.DEFAULT_COLOR,
  },
  overlayFooter: {
    backgroundColor: "#243251",
  },
});

export default emptyPageStyles;
